exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-container .el-form[data-v-bba44780]{display:flex;flex-wrap:wrap;gap:5%}.action-container .el-form>.el-form-item[data-v-bba44780]{margin-right:inherit;flex-basis:30%;flex-shrink:0}.main-container[data-v-bba44780]{padding-top:0.10417rem}\n", ""]);

// exports
